import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Actions} from '../../../common/actions';
import {Icon, Table, Card, Button, Popup, Loader, Dropdown, Tab} from 'semantic-ui-react';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {vehicleMasterRequestStatus} from '../../../common/constants/lists';
import {cloneDeep} from 'lodash';
import VehicleListTable from './VehicleListTable';


const allStatus = 'ALL';

const panes = [
  {'menuItem': 'Activos'},
  {'menuItem': 'Inactivos'},
];

class MasterVEHList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'countRows': 0,
      'activeTabIndex': 0,
      'state': 0,
      'status': 'ALL',
    };
  }
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.MasterVehicleList, scopes.See)) {
      this.props.push(paths.AccessDenied);
      return;
    }
    const status = this.state.activeTabIndex;
    this.search(status);
  }

  search(status) {
    this.props.fetchMasterVEHSData({status});
  }

  changeStatus(value) {
    const state = value === allStatus ? '' : value;
    const status = this.state.activeTabIndex;
    this.props.fetchMasterVEHSData({state, status});
  }

  changeTabIndex(event, data) {
    const status = data.activeIndex;
    this.setState({'activeTabIndex': data.activeIndex});
    this.search(status);
  }

  renderSearchButton() {
    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to={paths.MasterVehicleFormAdd}
      >
        Añadir nuevo
      </Button>
      
    );
  }
  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    });
  };
  getStatusOptions() {
    const options = cloneDeep(vehicleMasterRequestStatus);
    options.push({'text': 'Todos', 'value': allStatus});
    return options;
  }

  renderOptionButton() {
    return (
      <Dropdown selection
        options={this.getStatusOptions()}
        search
        name='list-invoices-container'
        onChange={(e, {value}) => this.changeStatus(value)}
        placeholder='Seleccione un Estado'
      />
    );
  }

  render() {
    const {countRows} = this.state;
    const {listMasterVEH} = this.props;
    const {loading} = this.props;
    return (
      <div className='set-sales-list'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento Vehículos</h2>
              <div className='title-bar-actions'>
                {this.renderOptionButton()}
                {this.renderSearchButton()}
              </div>
            </div>
          </div>
        </Card>
        <Tab
          menu={{'secondary': true, 'pointing': true, 'color': 'red'}}
          panes={panes}
          activeIndex={this.state.activeTabIndex}
          onTabChange={this.changeTabIndex.bind(this)}
        />
        <Card fluid raised>
          {loading ? (
            this.renderLoadMasterVEH()
          ) : (
            <VehicleListTable
              dataTable={listMasterVEH}
              countRows={countRows}
              handleChange={this.handleChange}
            />
          )}
          <Table striped className='toyota-grid'>
            <Table.Header>
            </Table.Header>
        
            <Table.Body>
            </Table.Body>
          </Table>
        </Card>
      </div>
    );
  }

  renderLoadMasterVEH() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderMasterVEH();
  }

  renderMasterVEH() {
    const {listMasterVEH} = this.props;
    return listMasterVEH.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.code}</Table.Cell>
          <Table.Cell textAlign='center'>{element.sfx}</Table.Cell>
          <Table.Cell textAlign='center'>{element.katashiki}</Table.Cell>
          <Table.Cell textAlign='center'>{element.description}</Table.Cell>
          <Table.Cell textAlign='center'>{element.creationUser}</Table.Cell>
          <Table.Cell textAlign='center'>{element.state}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Popup
              trigger={
                <Link to={`/maestro-vehiculos/editar/${element.code}`}>
                  <Icon name='write' color='blue' size='large' />
                </Link>
              }
              content='Editar'
              position='top center'
              inverted
            />
          </Table.Cell>
        </Table.Row>
      );
    });
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.masterVehicle.loading,
    'listMasterVEH': state.masterVehicle.masterVEHlist,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
  };
};

const {
  fetchMasterVEHSData,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  fetchMasterVEHSData,
})(MasterVEHList));
